import styled from "styled-components"

export const FlexContainer = styled.div`
  width: 100%;
`
// Removed to help with possible on-screen positioning problems
// display: flex;
// flex-direction: column;
// align-items: center;
// justify-content: center;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const AudioBase = styled(FlexContainer)`
  width: 100%;
  margin: 0 auto;

  .mm--replace-audio {
    text-align: center;
  }

  audio {
    display: block;
    margin: 0 auto;
  }
`

export const AudioViewWrapper = styled(AudioBase)`
  width: 80%;
`

export const AudioEditWrapper = styled(AudioBase)`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .mm--replace-audio {
    opacity: 0;
    margin-bottom: 1rem;
    transition: opacity 0.3s;
  }

  .EditButton i.Pathicon {
    color: #fff !important;
  }

  &:hover .mm--replace-audio {
    opacity: 1;
  }

  .BlocksAudioPlayer {
    width: 600px;
  }
`
